// In-app browsers (Facebook, Instagram, Messenger, TikTok…) — Google blocks
// "Continue with Google" inside them (error 403: disallowed_useragent), so
// visitors from ads need to open the page in their phone's own browser first.

const IN_APP_UA = /FBAN|FBAV|FB_IAB|FBIOS|FB4A|Instagram|Messenger|Line\/|TikTok|musical_ly|BytedanceWebview|Snapchat|LinkedInApp|Pinterest|Twitter/i;

export const isInAppBrowser = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // Android WebViews mark themselves with "; wv)".
  return IN_APP_UA.test(ua) || /; wv\)/.test(ua);
};

// Which app they're in, for the wording ("Instagram", "Facebook"…).
export const inAppName = () => {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (/Instagram/i.test(ua)) return 'Instagram';
  if (/Messenger/i.test(ua)) return 'Messenger';
  if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(ua)) return 'Facebook';
  if (/TikTok|musical_ly|Bytedance/i.test(ua)) return 'TikTok';
  return 'this app';
};

export const isIOS = () => /iPhone|iPad|iPod/i.test((typeof navigator !== 'undefined' && navigator.userAgent) || '');

// iOS major version from the user agent ("iPhone OS 16_5", Instagram's
// "iOS 16_5"), or null.
export const iosVersion = () => {
  const m = ((typeof navigator !== 'undefined' && navigator.userAgent) || '').match(/(?:iPhone OS|CPU OS|iOS) (\d+)_/);
  return m ? Number(m[1]) : null;
};

// Whether "Open in browser" can work: Android yes; iPhone only from iOS 17
// (when the x-safari-https link arrived).
export const canJumpToBrowser = () => !isIOS() || (iosVersion() || 0) >= 17;

// Try to open `url` in the phone's own browser. Android: an intent URL with
// no app named goes to their default browser (Chrome, Samsung Internet,
// Firefox…), falling back to the same page. iOS 17+: x-safari-https opens
// Safari; older iOS ignores it, so the pop-up also explains the ••• → "Open
// in browser" route.
export const openInExternalBrowser = (url = window.location.href) => {
  const u = new URL(url);
  const scheme = u.protocol.replace(':', '');
  const rest = `${u.host}${u.pathname}${u.search}${u.hash}`;
  window.location.href = isIOS()
    ? `x-safari-${scheme}://${rest}`
    : `intent://${rest}#Intent;scheme=${scheme};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;S.browser_fallback_url=${encodeURIComponent(url)};end`;
};
